module.exports = __webpack_public_path__ + "static/media/HappyFace-2x.4da3bcea.png";